import { render, staticRenderFns } from "./text-image.vue?vue&type=template&id=5c18219a&scoped=true"
import script from "./text-image.vue?vue&type=script&lang=js"
export * from "./text-image.vue?vue&type=script&lang=js"
import style0 from "./text-image.vue?vue&type=style&index=0&id=5c18219a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c18219a",
  null
  
)

export default component.exports